export const getUserPaymentDetails = (state) => state.payment.userPaymentDetails;
